<template>
  <div class="info">
    <div class="ls-pagehead">
      <div>
        <div class="ls-crumb">Overzicht</div>
        <h1>Info &amp; account</h1>
      </div>
    </div>

    <!-- Account -->
    <div class="ls-card ls-block">
      <div class="ls-block-head">
        <span class="material-icons">account_circle</span>
        <h2>Jouw account</h2>
        <span class="ls-status" :class="provisioned ? 'ls-ok' : 'ls-warn'" style="margin-left:auto">
          <span class="ls-dot"></span>{{ provisioned ? 'Goedgekeurd' : 'Nog goed te keuren' }}
        </span>
      </div>
      <div class="ls-block-body">
        <div class="ls-kv" style="margin-bottom:16px" v-if="user.data">
          <span>Aangemeld als</span><b class="ls-mono">{{ user.data.email }}</b>
        </div>

        <div class="ls-rights-title">Rechten per school</div>
        <div class="ls-rights">
          <span v-for="s in schoolList" :key="s" class="ls-right" :class="{ 'ls-on': hasSchool(s) }">
            <span class="material-icons">{{ hasSchool(s) ? 'check' : 'remove' }}</span>{{ s }}
          </span>
        </div>

        <button class="ls-btn ls-ghost ls-sm" style="margin-top:16px" @click="showUserClaims = !showUserClaims">
          {{ showUserClaims ? 'Verberg' : 'Toon' }} volledige claims
        </button>
        <details class="ls-json" v-if="showUserClaims" style="margin-top:10px" open>
          <summary>Ruwe userclaims</summary>
          <json-tree :data="user.claims || {}" :level="1"></json-tree>
        </details>
      </div>
    </div>

    <!-- Aan de slag -->
    <div class="ls-card ls-block">
      <div class="ls-block-head">
        <span class="material-icons">flag</span>
        <h2>Aan de slag — jaarlijkse setup</h2>
      </div>
      <div class="ls-block-body">
        <ol class="ls-steps">
          <li><b>Informat</b> — zet per school de referentiedatum op <span class="ls-mono">vandaag</span> of op de startdatum <span class="ls-mono">03/09/JJJJ</span>, en het schooljaar op <span class="ls-mono">JJJJ-JJ</span>.</li>
          <li><b>Workspace</b> — pas het globale schooljaar aan bij <router-link to="/workspaceglobals">Workspace-situatie</router-link>, in de lange notatie <span class="ls-mono">JJJJ-JJJJ</span>. Dit bepaalt in welke Classroom leerlingen belanden.</li>
          <li><b>Nieuw schooljaar</b> — verwijder alle school-collections én de google-collections (behalve <span class="ls-mono">google-orgs&nbsp;›&nbsp;orgs</span>) en laat alles opnieuw synchroniseren.</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({ user: 'user' }),
    provisioned () { return !!(this.user.claims && this.user.claims.provisioned) }
  },
  data () {
    return {
      showUserClaims: false,
      schoolList: ['FEA', 'FMA', 'FML', 'FMT', 'FMM', 'FMP', 'FPP', 'SGFV']
    }
  },
  methods: {
    hasSchool (s) {
      return !!(this.user.claims && this.user.claims.schools && this.user.claims.schools[s])
    }
  }
}
</script>

<style scoped>
.info { display: flex; flex-direction: column; gap: 18px; }
.ls-block { overflow: hidden; }
.ls-block-head { display: flex; align-items: center; gap: 10px; padding: 14px 18px; border-bottom: 1px solid var(--ls-line); background: var(--ls-surface-2); }
.ls-block-head .material-icons { color: var(--ls-primary); }
.ls-block-head h2 { font-family: var(--ls-sans); font-size: 16px; font-weight: 700; margin: 0; }
.ls-block-body { padding: 18px; }
.ls-rights-title { font-size: 11px; text-transform: uppercase; letter-spacing: .07em; color: var(--ls-ink-3); font-weight: 700; margin-bottom: 8px; }
.ls-rights { display: flex; flex-wrap: wrap; gap: 8px; }
.ls-right { display: inline-flex; align-items: center; gap: 5px; font-size: 12.5px; font-weight: 600; font-family: var(--ls-mono); padding: 5px 11px 5px 8px; border-radius: 8px; background: var(--ls-idle-bg); color: var(--ls-ink-3); border: 1px solid var(--ls-line); }
.ls-right .material-icons { font-size: 15px; }
.ls-right.ls-on { background: var(--ls-ok-bg); color: var(--ls-ok); border-color: transparent; }
.ls-steps { margin: 0; padding-left: 20px; display: flex; flex-direction: column; gap: 10px; color: var(--ls-ink); font-size: 14px; line-height: 1.55; }
.ls-steps b { font-family: var(--ls-sans); }
</style>
